module.exports = __webpack_public_path__ + "static/media/ref-icon.6047a2b6.png";